declare const window: any

const addToken = (params: any) => window.ethereum.request({ method: 'wallet_watchAsset', params })

export const isMetamask = ()=>{
    return window.ethereum?.isMetaMask === true;
}

export const addToMetamask = (address, symbol, decimals, imagePath) => {
    if (!isMetamask()) {
        return;
    }
    addToken({
        type: 'ERC20',
        options: {
        address,
        symbol,
        decimals,
        image: imagePath ? String(imagePath).startsWith("http")?imagePath:`${window.location.origin}${imagePath}` : undefined
        }
    })
}

export const addEbenToMetamask = ()=>{
    addToMetamask("0x77CB87b57F54667978Eb1B199b28a0db8C8E1c0B", "EBEN", 18, "/images/ben/EBEN64x64.png")
};